import { getTranslatedRoute } from "./routeMap";

const BASE_URL = "https://impact-window-repair-miami.com";

function normalizePath(path: string): string {
  let p = path;
  if (!p.endsWith("/")) p = p + "/";
  if (!p.startsWith("/")) p = "/" + p;
  return p;
}

export interface HreflangEntry {
  hreflang: string;
  href: string;
}

export function getHreflangs(
  currentPath: string,
  currentLang: "en" | "es"
): HreflangEntry[] {
  const normalized = normalizePath(currentPath);

  const enPath =
    currentLang === "en" ? normalized : getTranslatedRoute(normalized, "en");
  const esPath =
    currentLang === "es" ? normalized : getTranslatedRoute(normalized, "es");

  return [
    {
      hreflang: "en-US",
      href: `${BASE_URL}${enPath}`,
    },
    {
      hreflang: "es-US",
      href: `${BASE_URL}${esPath}`,
    },
    {
      hreflang: "x-default",
      href: `${BASE_URL}${enPath}`,
    },
  ];
}